"use strict";

/**
 * ## AjustBlocs
 *  - AJUSTE LES MARGES BASSE DU DERNIER BLOC AVANT FOOTER SI UN BLOC DE COULEUR
 */
export const ajustBlocs = {
  init() {
    this.colors = ["dark", "grey", "black"];

    if (document.querySelector(".footer")) {
      this.container = document.querySelector(".container");
      this.footer = document.querySelector(".footer");
      this.ajustMarginBeforeFooter();
    }
  },

  /**
   * AJUSTE LES MARGES BASSE DU DERNIER BLOC AVANT FOOTER SI UN BLOC DE COULEUR
   */
  ajustMarginBeforeFooter() {
    let lastBlocOfPage;

    lastBlocOfPage = this.container.children[
      this.container.children.length - 1
    ];

    this.colors.forEach(color => {
      if (lastBlocOfPage.classList.contains(color)) {
        lastBlocOfPage.style.marginBottom = "0";
      }
    });
  }
};
